import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../assets/images/logo.jpg';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    if (window.location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <Link to="/" className="footer-logo">
              <img src={logo} alt="Tech Update" />
            </Link>
            <p>Building innovative digital solutions for startups and businesses worldwide.</p>
            <div className="footer-social">
              <a href="https://x.com/gettechupdate" target="_blank" rel="noopener noreferrer" aria-label="Twitter/X"><i className="fab fa-twitter"></i></a>
              <a href="https://www.linkedin.com/company/14508055" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
              <a href="https://www.instagram.com/gettechupdate" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="https://www.youtube.com/TechUpdate" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="fab fa-youtube"></i></a>
            </div>
          </div>
          <div className="footer-section">
            <h4>Our Services</h4>
            <ul>
              <li><a href="/services/android-app-development" >Android App Development</a></li>
              <li><a href="/services/web-development" >Web Development</a></li>
              <li><a href="/services/wordpress-development" >WordPress Development</a></li>
              <li><a href="/services/ui-ux-design" >UI/UX for App & Web</a></li>
              <li><a href="/services/ios-development" >iOS Development</a></li>
              <li><a href="/services/ai-chatbots-smart-tools" >AI Chatbots & Smart Tools</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              
              <li><Link to="/contact" onClick={scrollToTop}>Contact Us</Link></li>
              <li><Link to="/about-us" onClick={scrollToTop}>About Us</Link></li>
              <li><Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" onClick={scrollToTop}>Terms of Service</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Our Products</h4>
            <ul>
              <li><a href="https://fingst.in/"><b>Fingst</b></a></li>
            </ul>
            <div className="footer-contact">
              <p><i className="fas fa-envelope"></i> info@gettechupdate.com</p>
              <p><i className="fas fa-phone"></i> +91 8269277543</p>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Tech Update. All Rights Reserved.</p>
          <div className="footer-links">
            <Link to="/terms-of-service" onClick={scrollToTop}>Terms of Service</Link>
            <span>|</span>
            <Link to="/privacy-policy" onClick={scrollToTop}>Privacy Policy</Link>
            <span>|</span>
            <Link to="/cookies-policy" onClick={scrollToTop}>Cookies Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

